import { useEffect, useRef, useState } from "react";
import CardTable, { CardTableProps } from "../CardTable/CardTable";

const ITEMS_PER_PAGE = 20;
const SCROLL_THRESHOLD = 0.7;

/**
 * Virtualized wrapper for CardTable that only renders visible items
 */
const VirtualizedCardTable = <T,>(props: CardTableProps<T>) => {
    const [visibleCount, setVisibleCount] = useState(ITEMS_PER_PAGE);
    const scrollRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setVisibleCount(ITEMS_PER_PAGE);
    }, [props.catalog.length]);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;

            if (scrollTop + windowHeight >= documentHeight * SCROLL_THRESHOLD) {
                setVisibleCount((prev) => Math.min(prev + ITEMS_PER_PAGE, props.catalog.length));
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [props.catalog.length]);

    const visibleCatalog = props.catalog.slice(0, visibleCount);

    return (
        <div ref={scrollRef}>
            <CardTable {...props} catalog={visibleCatalog} />
        </div>
    );
};

export default VirtualizedCardTable;
